<div class="unifiedActionBarWrapper"
  *ngrxLet="combined$; let value;">
  <div class="flex flex-row items-center w-full">
    <div class="flex flex-row items-center
                  min-w-[220px]">

      <app-breadcrumbs itemName="location"
                       [itemsTotal]="value.total | number:'1.0-0':translate.currentLang"
        [selectedItems]="value.selectedRowsCount">
      </app-breadcrumbs>
    </div>

    <div id="address-list-action-bar">

      <!--  TODO: implement location list loading-->
      @if (value?.ongoingActions.length) {
        <mat-progress-bar color="primary" mode="indeterminate" id="action-active-bar"
        ></mat-progress-bar>
      }

      <div id="action-buttons" class="flex">

          <div class="action-button"
               (click)="locationListService.copyStringToClipboard()"
               [ngClass]="{'disabled': !value?.canCopyToClipboard}"
               appGtagEvent
               trackOn="click"
               action="Copy"
               category="Multi-location action [overhaul]"
               [params]="{event_label: 'Copy location(s) info into clipboard' }">
            <div class="iconContainer">
              <mat-icon svgIcon="content_copy"></mat-icon>
            </div>
            <div class="label">Copy</div>
          </div>

          <div class="action-button"
               (click)="locationListService.openBatchModifyLocationGroupsDialog()"
               [ngClass]="{'disabled': !value.canTransfer}"
               appGtagEvent
               trackOn="click"
               action="open batch-modify location groups popup"
               category="Multi-location action [overhaul]"
               [params]="{event_label: 'Open batch-modify location groups popup'}">
            <div class="iconContainer">
                <mat-icon svgIcon="batch_modify_location_groups"></mat-icon>
            </div>
            <div class="label">Transfer</div>
          </div>

          <div class="action-button"
               [ngClass]="{'disabled': !value?.canUpdateInGbp}"
               (click)="locationListService.updateInGbpAndSendToGoogleAnalytics()">
            <div class="iconContainer">
              <mat-icon svgIcon="update_in_gmb"/>
            </div>
            <div class="label">Update in GBP</div>
          </div>

          <div class="action-button"
               [ngClass]="{'disabled': !value?.canRefreshGbp}"
               (click)="locationListService.refreshGbpConnections()"
               appGtagEvent
               trackOn="click"
               action="get updates from GMB"
               category="Multi-location action [overhaul]"
               [params]="{event_label: 'Get updates from GMB for multiple locations'}">
            <div class="iconContainer">
              <mat-icon svgIcon="get_gmb_updates"/>
            </div>
            <div class="label">Get GBP updates</div>
          </div>

          <div class="action-button"
               [ngClass]="{'disabled': !value?.areRowsSelected}"
               [matMenuTriggerFor]="moreBulkActionsMenu">
            <div class="iconContainer">
              <mat-icon svgIcon="more_vert"/>
            </div>
            <div class="label">More</div>
          </div>


        <mat-menu #moreBulkActionsMenu="matMenu">
          <button mat-menu-item
            class="dropdown-menu-option"
            [disabled]="!value?.canBulkAcceptDiffs"
            (click)="locationListService.openBulkAcceptDifferencesDialog()"
            appGtagEvent
            trackOn="click"
            action="bulk accept difference [overhaul]"
            category="Multi-location action"
            [params]="{event_label: 'Bulk accept differences for multiple locations'}">
            <mat-icon svgIcon="bulk_accept_differences"></mat-icon>
            Accept differences
          </button>

          <button mat-menu-item
            class="dropdown-menu-option"
            [disabled]="!value?.canArchive"
            (click)="locationListService.archiveLocations()"
            appGtagEvent
            trackOn="click"
            action="archive"
            category="Multi-location action [overhaul]"
            [params]="{event_label: 'Archive multiple locations'}">
            <mat-icon svgIcon="archive_locations"></mat-icon>
            Archive
          </button>

          <button mat-menu-item
            class="dropdown-menu-option"
            [disabled]="!value?.canBlacklist"
            (click)="locationListService.openBlacklistFieldsDialog()"
            appGtagEvent
            trackOn="click"
            action="blacklist"
            category="Multi-location action [overhaul]"
            [params]="{event_label: 'Blacklist fields of multiple locations'}">
            <mat-icon svgIcon="blacklist_locations">
            </mat-icon>
            Blacklist
          </button>

        </mat-menu>

        <mat-divider [vertical]="true" class="mr-2 pl-2"></mat-divider>

        <div class="action-button"
             (click)="chooseImportFile()"
             [ngClass]="{'disabled': !value?.canImport}">
          <div class="iconContainer">
            <mat-icon svgIcon="import_locations"></mat-icon>
          </div>
          <div class="label">Import</div>
        </div>

        <input type="file"
          accept=".csv"
          #importFileInput
          style="display: none"
          (change)="onImportFileSelected()"/>

        <div class="action-button"
             [matMenuTriggerFor]="exportLocationsMenu"
             [ngClass]="{'disabled': !value?.canExport}">
          <div class="iconContainer">
            <mat-icon svgIcon="export_locations"/>
          </div>
          <div class="label">Export</div>
        </div>

        <app-bulk-validate/>

        <app-restart-cc-sync/>

        <app-restart-datasync/>
      </div>

      <div class="flex items-center h-full">
        <mat-divider [vertical]="true" class="mr-2 pl-2"></mat-divider>

        <div class="action-button"
             (click)="locationListService.clearSorting()"
             [ngClass]="{'disabled': !value?.isSortingApplied}">
          <div class="iconContainer">
            <mat-icon svgIcon="clear_sorting"/>
          </div>
          <div class="label">Clear sorting</div>
        </div>

        <div class="action-button"
             (click)="locationListService.clearFilters()"
             [ngClass]="{'disabled': !value?.areFiltersApplied}">
          <div class="iconContainer">
            <mat-icon svgIcon="filter_alt_off_outline"
                      matBadge="{{ value?.filtersCount }}"
                      matBadgeOverlap="false"
                      [matBadgeHidden]="!value?.areFiltersApplied"/>
          </div>
          <div class="label">Clear filters</div>
        </div>

        <div id="refreshButton"
             class="action-button"
             (click)="updateListData()"
             [ngClass]="{'disabled': value.loading,
                         'highlighted': value.potentiallyStaleList}"
             matTooltip="{{value.potentiallyStaleList ?
                        'Refresh locations - last list refresh >= ' + DATA_STALE_AFTER_HR + 'h ago' :
                        'Refresh locations'}}"
             appGtagEvent
             trackOn="click"
             action="Refresh locations"
             category="Multi-location action [overhaul]">
          <div class="iconContainer">
            @if (!value?.loading) {
              <mat-icon svgIcon="refresh"></mat-icon>
            } @else {
              <mat-spinner [diameter]="24"></mat-spinner>
            }
          </div>
          <div class="label">Refresh</div>
        </div>

        <!-- Column Settings menu (enable/disable columns) -->
        <div class="action-button"
             [matMenuTriggerFor]="columnMenu?.menu"
             #columnMenuTrigger="matMenuTrigger"
             appGtagEvent
             trackOn="click"
             action="Open column display menu [overhaul]"
             category="Adapt column display">
          <div class="iconContainer">
            <mat-icon svgIcon="view_week_outline"></mat-icon>
          </div>
          <div class="label">Columns</div>
        </div>
      </div>

    </div>

    <app-column-menu #columnMenu></app-column-menu>

    <mat-menu #exportLocationsMenu="matMenu">
      <div mat-menu-item
        class="dropdown-menu-option"
        (click)="locationListService.exportLocationsToGoogleSheets()">
        <mat-icon svgIcon="export_to_sheet"></mat-icon>
        Locations
      </div>
      <div mat-menu-item
        class="dropdown-menu-option"
        (click)="locationListService.exportDifferencesToGoogleSheets()">
        <mat-icon svgIcon="export_differences"></mat-icon>
        Differences
      </div>
      <div mat-menu-item
        class="dropdown-menu-option"
        (click)="locationListService.exportDuplicateLocations()">
        <mat-icon svgIcon="mark_duplicate"></mat-icon>
        Duplicates
      </div>
      <div mat-menu-item
        class="dropdown-menu-option"
           [matMenuTriggerFor]="allStarredResultsMenu">
        <mat-icon svgIcon="starred_all_locations"></mat-icon>
        All starred results
      </div>
      <div mat-menu-item
        class="dropdown-menu-option"
           (click)="locationListService.exportStarredCCSearchResults(true)">
        <mat-icon svgIcon="starred_unlinked"></mat-icon>
        Unlinked starred results only
      </div>
      <div mat-menu-item
        class="dropdown-menu-option"
        (click)="locationListService.exportPlaceNames()">
        <mat-icon svgIcon="spellcheck"></mat-icon>
        Place names
      </div>
      <div mat-menu-item
        class="dropdown-menu-option"
        [matMenuTriggerFor]="exportGbpUsersMenu">
        <mat-icon svgIcon="people"></mat-icon>
        Google Business Profile users
      </div>
    </mat-menu>

    <mat-menu #allStarredResultsMenu="matMenu">
      <button mat-menu-item
              (click)="locationListService.exportStarredCCSearchResults(false)">
        <mat-icon svgIcon="starred_all_locations"></mat-icon>
        <span>All locations</span>
      </button>

      <button mat-menu-item
              (click)="locationListService.exportStarredCCSearchResults(false, locationListService.getFilteredLocationIds$())"
              [disabled]="!value.areFiltersApplied">
        <mat-icon svgIcon="starred_filtered"></mat-icon>
        <span>Filtered locations only</span>
      </button>

      <button mat-menu-item
              (click)="locationListService.exportStarredCCSearchResults(false, selectedRowsIds$)"
              [disabled]="!value.selectedRowsCount">
        <mat-icon svgIcon="starred_selected"></mat-icon>
        <span>Selected locations only</span>
      </button>
    </mat-menu>

    <mat-menu #exportGbpUsersMenu="matMenu">
      <button mat-menu-item
        (click)="locationListService.exportGbpUsers(locationLevel.GROUP)">
        <mat-icon svgIcon="export_to_sheet"></mat-icon>
        <span>Location group level users to Google Sheets</span>
      </button>

      <button mat-menu-item
        (click)="locationListService.exportGbpUsers(locationLevel.SINGLE)">
        <mat-icon svgIcon="export_to_sheet"></mat-icon>
        <span>Single location level users to Google Sheets</span>
      </button>
    </mat-menu>

  </div>
</div>




